export enum ViewListingTypes {
  LIST = "list",
  KANBAN = "kanban",
  MAP = "map",
}

export enum TabDataTypes {
  REVIEW = "review",
  OPEN = "open",
  APPROVED = "approved",
  ARCHIVED = "archived",
}

export enum TableSortTypes {
  ASCEND = "asc",
  DESCEND = "desc",
}
